import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import { canvasBreakdownLogic } from './canvas_breakdown.logic';
import { CanvasBreakdownReadView } from './CanvasBreakdownViews';

export const canvasBreakdownPlugin: ActivityPlugin<'canvas_breakdown'> = {
  ...canvasBreakdownLogic,
  displayName: GAME_MODE_CATALOG.canvas_breakdown.displayName,
  icon: GAME_MODE_CATALOG.canvas_breakdown.icon,
  HostView: CanvasBreakdownReadView,
  StudentView: CanvasBreakdownReadView,
  ProjectorView: CanvasBreakdownReadView,
};

export { demoCanvasBreakdownPayload } from './canvas_breakdown.logic';
